"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var Loading = function Loading() {
  return React.createElement("div", {
    className: 'd-block text-center mt-4'
  }, React.createElement("i", {
    className: 'd-block text-center fas fa-3x fa-spinner fa-pulse'
  }), React.createElement("div", {
    className: 'mt-3'
  }, "Loading..."));
};
exports.Loading = Loading;